import {
  MessageContextSchema,
  MessageTranslation,
  translateMessage,
} from "src/generated/hooks/avela-ai/requests";

export type TranslateMessageResponse =
  | {
      status: "fulfilled" | "rejected";
      reason?: string;
    } & MessageTranslation;

function rejected(reason: any, language: string): TranslateMessageResponse {
  return {
    status: "rejected",
    reason: errorToString(reason),
    subject: null,
    email: null,
    sms: null,
    translated_language: language,
  };
}

function fulfilled(translation: MessageTranslation): TranslateMessageResponse {
  return {
    status: "fulfilled",
    ...translation,
  };
}

export async function translateMessages(
  languages: string[],
  subject: string,
  html: string,
  smsText: string,
  messageContext?: MessageContextSchema,
  abortSignal?: AbortSignal
): Promise<TranslateMessageResponse[]> {
  return await Promise.all(
    languages.map((lang) =>
      translateMessage({
        body: {
          subject,
          email: html,
          sms: smsText,
          target_languages: [lang],
          message_context: messageContext,
        },
        signal: abortSignal,
      })
        .then((result) => {
          if (
            !result.data?.translations ||
            result.data.translations[0] === undefined
          ) {
            return rejected("Translation response is empty", lang);
          }
          return fulfilled(result.data.translations[0]);
        })
        .catch((error) => {
          if (!isAbortError(error)) {
            console.error("translateMessage error", error);
          }
          return rejected(error, lang);
        })
    )
  );
}

function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }
  return error instanceof Error && error.name === "AbortError";
}

function errorToString(error: any): string {
  if (typeof error === "object" && error && error.error) {
    if (error.error === "translation_truncated") {
      return "The message is too long. Try shortening the message and try again later, or manually enter a translation for this language below.";
    }
    if (error.error === "invalid_target_languages") {
      return "The target language is not supported. Please select a different language.";
    }
  }

  return "Oops! Something went wrong! Try again later, or manually enter a translation for this language below.";
}
